//在index.js中引入axios
import axios from 'axios';
import {message} from 'antd'
import ev from '../ev';
import store, {state} from '../store';
import {setToken, getToken, tokenStatus, NEED_REFRESH} from "../store/token";
import {v4 as uuid} from "uuid";
import ApiServices, {
    CHANGE_CURRENT_MERCHANT,
    LOAD_AUTH_URL,
    LOAD_CONFIG,
    LOGIN,
    REFRESH_TOKEN
} from "../config/ApiServices";
import _ from 'lodash';
import {RefreshTokenEvent} from "../events/RefreshTokenEvent";
import EventDispatcher from "../events";
import {sleep} from "./functions";
//区分开发环境还是生产环境基础URL
export const baseURL = process.env.REACT_APP_API_GATEWAY
//设置axios基础路径
const service = axios.create({
    baseURL: baseURL
})

let refreshingToken = false;
const NOT_NEED_TOKEN_APIS = [
    REFRESH_TOKEN,
    LOGIN,
    LOAD_CONFIG,
    LOAD_AUTH_URL,
];

// 请求拦截器
service.interceptors.request.use(async (config) => {
    // 判断是否主动刷新token中，拥塞后续请求，知道token完成刷新,获取超时

    let needToken = !_.find(NOT_NEED_TOKEN_APIS, (key) => {
        return ApiServices[key]['url'] === config.url
    });
    // ApiServices;
    if (needToken) {
        while(refreshingToken) {
            await  sleep(0.2);
        }
        // 每次发送请求之前本地存储中是否存在token，也可以通过Redux这里只演示通过本地拿到token
        // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        let token = getToken(state);
        if (!token) {
            return ;
        }
        if (tokenStatus(state) === NEED_REFRESH) {
            refreshingToken = true;
            token = await EventDispatcher.dispatch(new RefreshTokenEvent({
                token: token
            }));
            if (token) {
                refreshingToken = false;
            }
        } else if (ApiServices[CHANGE_CURRENT_MERCHANT]['url'] === config.url) {
            refreshingToken = true;
        }
        config.headers = {
            "Content-Type": "application/json",
            'Authorization': 'bearer ' + token,
            'Request-Id': uuid(),
        }
    } else {
        config.headers = {
            "Content-Type": "application/json",
            'Request-Id': uuid(),
        }
    }
    //设置请求头

    return config
}, error => {
    return error;
});

// 响应拦截器
service.interceptors.response.use(response => {
    if (!response || !response.data) return message.error('网络不稳定，请稍后再尝试登陆！')
    let {status} = response;
    let {code, meta} = response.data;
    if (meta && meta.token) {// 接口刷新了token
        if (!refreshingToken) {
            refreshingToken = true;
        }
        let token = {
            ...meta.token,
            value: meta.token['token'] !== undefined ? meta.token['token'] : meta.token['value'],
            refreshTtl: meta.token['refresh_ttl'],
        };
        store.dispatch(setToken(token));
        setTimeout(() => {
            refreshingToken =false;
        }, 300);
    }
    if (status === 200 && code === 200) {
        if (code) {
            return response.data;
        }
    } else {
        if (code > 1000 && code < 2000) {
            ev.emit('login', true);
        } else {
            message.error(response.data.message).then(r => console.log(response.data.message));
        }
    }
})
//最后把封装好的axios导出
export default service;
